<template>
  <v-app>
    <v-app-bar app color="purple" dark>
      <div class="d-flex align-center">
        <v-icon large>mdi-timer-cog</v-icon>
        <h3 class="ml-2">Interval Timer Data CRUD</h3>
      </div>
    </v-app-bar>

    <v-main>
      <v-container>
        <transition appear name="fade" mode="out-in">
          <v-row
            v-if="timerData.workout == null || timerData.workout == undefined"
            key="selection"
          >
            <v-col cols="12">
              <v-card class="mx-auto" max-width="500">
                <v-card-text>
                  <WorkoutSelectionForm @formSubmit="workoutSelected" />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else key="timer">
            <v-col cols="12">
              <v-card class="mx-auto" max-width="500">
                <v-card-text>
                  <WorkoutFlowControl
                    v-if="timerData"
                    :workout="timerData.workout"
                    :modality="timerData.modality"
                    :pace="timerData.pace"
                  ></WorkoutFlowControl>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import WorkoutFlowControl from "./components/WorkoutFlowControl";
import WorkoutSelectionForm from "./components/WorkoutSelectionForm";

export default {
  name: "App",

  components: {
    WorkoutFlowControl,
    WorkoutSelectionForm,
  },

  data: () => ({
    timerData: {
      workout: null,
      autoplay: false,
      modality: null,
      anPace: null,
      aePace: null,
    },
  }),
  methods: {
    nextDisabled() {
      if (this.window === 3) return true;
      if (this.window === 1 && !this.dataValid) return true;
      else return false;
    },
    workoutSelected: function (data) {
      this.timerData.workout = data.workout;
      this.timerData.autoplay = data.autoplay;
      //this.timerData.modality = data.modality;
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
